import Link from "@/components/link"
import { ArrowRight } from "lucide-react"

import { Button } from "@anysola/ui/button"
import { launchListHref } from "@/lib/nav-links"

/** The home page's one call to action. */
function LaunchListButton({ className }: { className?: string }) {
  return (
    <Button
      size="xl"
      className={className}
      render={<Link href={launchListHref} />}
    >
      Join the launch list
      <ArrowRight className="size-4" />
    </Button>
  )
}

export { LaunchListButton }
